<div class="loginheader" style="display: inline-flex;">
  <div class="col-md-12 col-xs-12 pull-right header-title">
    <div class="pull-left col-sm-12 col-md-8 col-md-offset-3">
      <img
        src="src/app/assets/images/login/goi-logo.png"
        class="pull-left"
        style="margin-right: 10px; padding: 10px;"
        alt="Logo"
        height="100"
      />
      <h1 style="color: #fff; margin-top: 10px;">
        National Programme for prevention and control of NCDs (NP-NCD)
      </h1>

      <!-- <span>
        <h5 style="color: #fff; line-height: 1.24; margin-left: 15px; font-size: 16px;">
          <span style="display: inline-block;">Comprehensive Primary Health Care</span>
          <div>
            Population based NCDs Prevention, Screening, Control and Management Initiative
          </div>
        </h5>
      </span> -->
    </div>
  </div>
</div>

<div class="container text-center">
  <img
    class="mt40"
    [src]="
      sharedService.isMobile() ? 'src/app/assets/images/login/mobile.png' : 'src/app/assets/images/login/tablet.png'
    "
    alt="tablet"
    height="80"
  />
  <p class="fs14 pt10 pb20">
    The portal version is not supported in {{ sharedService.isMobile() ? 'mobile' : 'tablet' }} device.
  </p>
  <span class="fs14 pt20 bold">Please use a laptop/desktop to access the portal.</span>
  <!-- <ul class="row list-unstyled">
    <li class="col-xs-0 col-sm-3"></li>
    <li class="col-xs-12 col-sm-6">
      <span class="row p0">
        <span class="col-xs-5">
          <img class="m10" src="src/app/assets/images/login/mobile.png" alt="mobile" weigth="100" height="100" />
          <br />
          <span>Phone</span>
        </span>
        <div class="col-xs-2 timeline">
          <div class="word">OR</div>
        </div>
        <span class="col-xs-5 p0">
          <img class="m10" src="src/app/assets/images/login/desktop.png" alt="mobile" weigth="100" height="100" />
          <br />
          <span>Desktop</span>
        </span>
      </span>
    </li>
    <li class="col-xs-0 col-sm-3"></li>
  </ul> -->
</div>
